var _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModelScale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 109.171,
    height: 85.469
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16893",
    opacity: 0.2,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12550",
    d: "M9.963 68.39v13.273"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12551",
    d: "M3.326 75.027h13.273"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16894",
    opacity: 0.2,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12552",
    d: "M72.962 1.5v9.773"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12553",
    d: "M68.076 6.386h9.773"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16895",
    opacity: 0.2,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12558",
    d: "M76.508 68.39a15.579 15.579 0 0015.579-15.579"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12559",
    d: "M92.091 52.811A15.579 15.579 0 00107.67 68.39"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12560",
    d: "M107.67 68.39a15.579 15.579 0 00-15.579 15.579"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12561",
    d: "M92.09 83.969A15.579 15.579 0 0076.511 68.39"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle Copy 4",
    d: "M27.849 25.026h50v50h-50z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.099 33.359)",
    stroke: "currentColor",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.5,
    height: 35.417,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 34.5,
    height: 32.417,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.849 33.359a10.417 10.417 0 11-10.417 10.417 10.417 10.417 0 0110.417-10.417z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.849 36.359c-4.09 0-7.417 3.327-7.417 7.417s3.327 7.416 7.417 7.416 7.416-3.327 7.416-7.416c0-4.09-3.327-7.417-7.416-7.417m0-3c5.753 0 10.416 4.664 10.416 10.417S58.602 54.192 52.85 54.192 42.432 49.53 42.432 43.776s4.664-10.417 10.417-10.417z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle",
    stroke: "currentColor",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M50.766 39.609h4.167v6.25h-4.167z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.266 41.109h1.167v3.25h-1.167z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle",
    fill: "none",
    d: "M13.071 8.85l20.136 13.08-13.08 20.136-20.136-13.08z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle",
    fill: "none",
    transform: "rotate(33 -15.458 31.721)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 18,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 7,
    height: 17,
    rx: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3",
    d: "M25.427 21.052l-3.041 1.007 3.356 2.18z",
    fill: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.00047
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3 Copy",
    d: "M16.162 35.315l-.316-3.188 3.356 2.18z",
    fill: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.00047
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle",
    transform: "rotate(33 -39.397 31.972)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h4v1H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 3
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle Copy",
    transform: "rotate(33 -34.334 33.472)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h4v1H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 3
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle Copy 2",
    transform: "rotate(33 -29.272 34.972)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h4v1H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 3
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle Copy 3",
    transform: "rotate(33 -24.209 36.472)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h4v1H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 3
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2 Copy",
    d: "M24.609 22.31l-7.63 11.746",
    fill: "none",
    strokeWidth: 1.00047
  })))));
}
export default SvgModelScale;


//////////////////
// WEBPACK FOOTER
// ./src/icons/model-scale.svg
// module id = 769
// module chunks = 11